import React from "react";
import { Document, Font } from "@react-pdf/renderer";
import { connect } from "react-redux";

import BankingInfo from "./BankingInfo";
import ConfidentialityAgreement from "./ConfidentialityAgreement";
import CSRForm from "./CSRForm";
import Form2 from "./Form2";
import FormF from "./FormF";
import NewFormNo11 from "./NewFormNo11";
import PersonalProfile from "./personalProfile";
import SEZForm from "./SEZForm";
import RobotoLight from "../../../util/Fonts/Roboto-Light.ttf";
import RobotoMediumFont from "../../../util/Fonts/Roboto-Medium.ttf";
import RobotoMediumItalic from "../../../util/Fonts/Roboto-MediumItalic.ttf";
import RobotoRegular from "../../../util/Fonts/Roboto-Regular.ttf";
import { getDeclarationPlace } from "../../../util/onBoardingDataFilters";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular
    },
    {
      src: RobotoLight,
      fontWeight: "light"
    },
    {
      src: RobotoMediumFont,
      fontWeight: "medium"
    },
    {
      src: RobotoMediumItalic,
      fontWeight: "medium",
      fontStyle: "italic"
    }
  ]
});

const OnboardingMain = React.memo(
  ({
    genders,
    maritalStatusList,
    otherBankDetails,
    personalDetails,
    relationShipList,
    states
  }) => {
    const isEmployeePermanent = !(
      personalDetails.cDKEmployeeType === 2 ||
      personalDetails.cDKEmployeeType === 3
    );
    return (
      <Document>
        <PersonalProfile
          candidateDetails={personalDetails}
          genders={genders}
          maritalStatusList={maritalStatusList}
          relationShipList={relationShipList}
          states={states}
        />
        {isEmployeePermanent && (
          <>
            <FormF
              candidateDetails={personalDetails}
              genders={genders}
              maritalStatusList={maritalStatusList}
              relationShipList={relationShipList}
              states={states}
            />
            <Form2
              candidateDetails={personalDetails}
              genders={genders}
              maritalStatusList={maritalStatusList}
              relationShipList={relationShipList}
              states={states}
            />
            <NewFormNo11
              candidateDetails={personalDetails}
              genders={genders}
              maritalStatusList={maritalStatusList}
              otherBankDetails={otherBankDetails}
              relationShipList={relationShipList}
              states={states}
            />
          </>
        )}
        {getDeclarationPlace(personalDetails.declarationPlace) ===
          "Hyderabad" && (
          <SEZForm candidateDetails={personalDetails} states={states} />
        )}
        {isEmployeePermanent && <CSRForm candidateDetails={personalDetails} />}
        <BankingInfo
          candidateDetails={personalDetails}
          otherBankDetails={otherBankDetails}
        />
        <ConfidentialityAgreement candidateDetails={personalDetails} />
      </Document>
    );
  }
);

const mapStateToProps = state => ({
  genders: state.candidateDetails.genders || [],
  maritalStatusList: state.candidateDetails.maritalStatusList || [],
  personalDetails: state.onBoardingDetails.personalDetails || {},
  otherBankDetails: state.onBoardingDetails.otherBankDetails || {},
  relationShipList: state.onBoardingDetails.relationShipList || [],
  states: state.candidateDetails.states || []
});

export default connect(mapStateToProps)(OnboardingMain);
